
















































































import ModelsCache from '@/models/ModelsCache';
import Movie from '@/models/soukai/Movie';

import Modal from '@/components/mixins/Modal';
import MoviePoster from '@/components/MoviePoster.vue';

export default Modal.extend({
    components: { MoviePoster },
    props: {
        movie: {
            type: Object as () => Movie,
            required: true,
        },
    },
    methods: {
        async addToCollection(watched: boolean) {
            const movie = this.movie;

            await this.$ui.loading(
                async () => {
                    if (watched)
                        await movie.watch();

                    await movie.fetchMissingAttributes();
                    await this.$media.moviesContainer!.relatedMovies.save(movie);
                    await ModelsCache.forgetDocument(this.$media.moviesContainer!.url);
                },
                `Adding **${movie.title}** to your collection...`,
            );

            this.$ui.showSnackbar(
                `[**${movie.title}**](route:/movies/${movie.uuid}) has been added to your collection!`,
                { transient: true },
            );
        },
    },
});
